import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import clsx from 'clsx'
import Typo from 'constants/typography'
import { bindActionCreators } from 'redux'
import sortDuck from 'components/sort/sort-options/duck'
import { hasLocizeTranslation } from 'lib/utils/locize'
import HomepageCategory from '../home-page-category/HomepageCategory'
import BestSellersQuickCategory from './best-sellers-quick-category/BestSellersQuickCategory'
import styles from './home-page-best-sellers.scss'
import HomefeedApiHandler from '../../../../lib/api/homefeed'

const HomepageBestSellers = ({ t, isPhone, updateSort }) => {
  const [bestSellers, setBestSellers] = useState([])

  useEffect(() => {
    updateSort('best_sellers')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const homefeedApiData =
          await HomefeedApiHandler.getHomefeedBestSellers()

        if (homefeedApiData) {
          const bestSellersData = homefeedApiData?.data?.map((data) => {
            const productIds = data?.relationships?.products?.data?.map(
              (productData) => productData?.id,
            )
            const products = productIds?.map((id) => {
              const product = homefeedApiData?.included?.find(
                (productData) => productData?.id === id,
              )
              return product
            })

            const productsList = products.map((product, idx) => {
              const productAttributes = product?.attributes
              const productImages = product?.attributes?.images
              const productPrice = productAttributes?.price
              const productStock = productAttributes?.stock
              const productInfo = {
                is_italist: productAttributes?.manufacturer?.is_italist,
                id_product: Number(product?.id),
                id_category_default:
                  product?.relationships?.default_category?.data?.id,
                manufacturer_name: productAttributes?.manufacturer?.name,
                price: productPrice?.original,
                name: productAttributes?.name,
                is_coming_soon: productAttributes?.is_coming_soon,
                category_link_rewrite: data?.attributes?.cta?.link_rewrite,
                hyphen_name: productAttributes?.link_rewrite,
                is_back_in_stock: productAttributes?.is_back_in_stock,
                is_low_stock: productStock?.is_low_stock,
                is_sold_out: productStock?.is_sold_out,
                stock_quantity: productStock?.quantity || 0,
                price_formatted: productPrice?.original_formatted,
                manufacturer: productAttributes?.manufacturer,
                full_cover_img_v2: productImages?.cover_url ?? '',
                full_flatlay_img_v2: productImages?.flatlay_url ?? '',
                full_hover_img_v2: productImages?.hover_url ?? '',
                discounted_price: productPrice?.discounted,
                reduction_type: productPrice?.reduction?.kind,
                reduction: productPrice?.reduction?.value,
                discount_from: productPrice?.discount_from,
                discount_to: productPrice?.discount_to,
                is_flash_sale: productPrice?.is_flash_sale,
                flash_sale_seconds_left: productPrice?.flash_sale_seconds_left,
                discounted_price_formatted: productPrice?.discounted_formatted,
                is_premium_product: false,
                reduction_formatted: productPrice?.reduction?.value_formatted,
                is_shoes: false,
                is_wishlist: productAttributes?.is_on_wishlist,
                best_seller_rank: idx + 1,
                isShowBestSellerText: !isPhone,
              }
              return productInfo
            })

            return {
              id: Number(data?.id),
              ...data?.attributes,
              products: productsList,
            }
          })

          setBestSellers(bestSellersData)
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    }
    fetchBestSellers()
  }, [isPhone])

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      {bestSellers?.map((bestSeller) => (
        <BestSellersQuickCategory
          key={bestSeller?.id}
          bestSeller={bestSeller}
        />
      ))}
      <React.Fragment>
        <div id="best-sellers-navigations-scroll-point" />
        <div className="home-page-best-sellers__titles">
          <span className={clsx(isPhone ? Typo.subtitle2 : Typo.title3)}>
            {hasLocizeTranslation(t, 'All', 'All')}
          </span>
          <span
            className={clsx(
              isPhone ? Typo.body2 : Typo.caption,
              'home-page-best-sellers__titles__sub-title',
            )}
          >
            {hasLocizeTranslation(t, 'Best Sellers', 'Best Sellers')}
          </span>
        </div>
        <HomepageCategory />
      </React.Fragment>
    </React.Fragment>
  )
}

HomepageBestSellers.defaultProps = {
  // refType: '',
}

HomepageBestSellers.propTypes = {
  // refType: PropTypes.string,
  t: PropTypes.func.isRequired,
  isPhone: PropTypes.bool.isRequired,
  auth: PropTypes.shape({}).isRequired,
  updateSort: PropTypes.func.isRequired,
}

export default compose(
  connect(
    (state) => ({
      auth: state.auth,
      isPhone: state.device.isPhone,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          updateSort: sortDuck.creators.update,
        },
        dispatch,
      ),
  ),
  withI18next(),
)(HomepageBestSellers)
